import { render, staticRenderFns } from "./MergeZonesPage.vue?vue&type=template&id=cbbe5bc4&scoped=true"
import script from "./MergeZonesPage.vue?vue&type=script&lang=js"
export * from "./MergeZonesPage.vue?vue&type=script&lang=js"
import style0 from "./MergeZonesPage.vue?vue&type=style&index=0&id=cbbe5bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbe5bc4",
  null
  
)

export default component.exports